<script setup lang="ts">
import { eventbus } from '@/core/eventbus'
import { config } from '@/core/config'
import AbbotDialog from '../dialog/AbbotDialog.vue'
import LocationDialog from '../dialog/LocationDialog.vue'

const dataTH = JSON.parse(JSON.stringify(config.locationData_th))
const dataEN = JSON.parse(JSON.stringify(config.locationData_en))
</script>

<template>
  <div class="dialog-content">
    <!-- Location for TH -->
    <LocationDialog id="location1-th" class="layout-right" :data="dataTH.location1_th" />
    <LocationDialog id="location2-th" class="layout-left" :data="dataTH.location2_th" />
    <LocationDialog id="location3-th" class="layout-left" :data="dataTH.location3_th" />
    <LocationDialog id="location4-th" class="layout-right2" :data="dataTH.location4_th" />
    <LocationDialog id="location5-th" class="layout-right" :data="dataTH.location5_th" />
    <LocationDialog id="location6-th" class="layout-right" :data="dataTH.location6_th" />
    <LocationDialog id="location7-th" class="layout-left" :data="dataTH.location7_th" />
    <AbbotDialog id="abbot-th" />
    <!-- Location for EN -->
    <LocationDialog id="location1-en" class="layout-right" :data="dataEN.location1_en" />
    <LocationDialog id="location2-en" class="layout-left" :data="dataEN.location2_en" />
    <LocationDialog id="location3-en" class="layout-left" :data="dataEN.location3_en" />
    <LocationDialog id="location4-en" class="layout-right2" :data="dataEN.location4_en" />
    <LocationDialog id="location5-en" class="layout-right" :data="dataEN.location5_en" />
    <LocationDialog id="location6-en" class="layout-right" :data="dataEN.location6_en" />
    <LocationDialog id="location7-en" class="layout-left" :data="dataEN.location7_en" />
    <AbbotDialog id="abbot-en" />
  </div>
</template>

<style scoped>
@import '../../styles/location-position.css';

#abbot-th,
#abbot-en {
  transform: rotate(90deg);
}
</style>
